import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import InviteUsersComponent from './invite-users.component';

let InviteUsersModule = angular
  .module('InviteUsers', [
    uiRouter
  ])
  .component('inviteUsers', InviteUsersComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state("inviteUsers", {
      url: '/inviteUsers',
      data: {
        authRequired: true,
        permsRequired: ['manage-perm', 'invite-user', 'view-profiles']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'inviteUsers'
        }
      }

    })
  })
  .name;

export default InviteUsersModule;



// WEBPACK FOOTER //
// ./src/app/pages/invite-users/invite-users.module.js